module.exports = __webpack_public_path__ + "assets/img/00157.8e98815f.png";